import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  age: number;
  content: string;
  image?: string;
}
export function TestimonialCard({
  name,
  location,
  age,
  content,
  image
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-10">
      <div className="flex items-center gap-1 mb-4" data-id="element-11">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-12" />)}
      </div>

      <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-13">"{content}"</p>

      <div className="flex items-center gap-3 mt-auto" data-id="element-14">
        <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center text-teal-700 font-bold text-lg" data-id="element-15">
          {name.charAt(0)}
        </div>
        <div data-id="element-16">
          <p className="font-bold text-gray-900 text-sm" data-id="element-17">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-18">
            {age} años • {location}
          </p>
        </div>
      </div>
    </div>;
}